import { z } from "zod";

import { INTEGRATION_STATUS, INTEGRATION_TYPE } from "../constants";

// responses
const connectedIntegrationResponseSchema = z.object({
  id: z.uuid().optional(),
  updated_at: z.string().optional(),
  status: z.literal(INTEGRATION_STATUS.CONNECTED),
  type: z.enum(INTEGRATION_TYPE),
  account_id: z.string().nullable().optional(),
});

const disconnectedIntegrationResponseSchema = z.object({
  id: z.never(),
  updated_at: z.never(),
  status: z.literal(INTEGRATION_STATUS.DISCONNECTED),
  type: z.enum(INTEGRATION_TYPE),
});

export const integrationResponseSchema = z.discriminatedUnion("status", [
  connectedIntegrationResponseSchema,
  disconnectedIntegrationResponseSchema,
]);

// requests
const stripeUpsertSchema = z.object({
  id: z.uuid().optional(),
  organization_id: z.uuid(),
  publishable_key: z.string().min(1, "Publishable key is required"),
  restricted_api_key: z.string().min(1, "Restricted API key is required"),
  type: z.literal(INTEGRATION_TYPE.STRIPE),
});

const zoomUpsertSchema = z.object({
  id: z.uuid().optional(),
  organization_id: z.uuid(),
  account_id: z.string().min(1, "Account ID is required"),
  client_id: z.string().min(1, "Client ID is required"),
  client_secret: z.string().min(1, "Client secret is required"),
  type: z.literal(INTEGRATION_TYPE.ZOOM),
});

const spruceUpsertSchema = z.object({
  id: z.uuid().optional(),
  organization_id: z.uuid(),
  token: z.string().min(1, "API token is required"),
  type: z.literal(INTEGRATION_TYPE.SPRUCE),
});

export const integrationUpsertSchema = z.discriminatedUnion("type", [
  stripeUpsertSchema,
  zoomUpsertSchema,
  spruceUpsertSchema,
]);
